<script lang="ts">
    import { onMount } from "svelte";
    import Router, { push, location } from "svelte-spa-router";

    import Mapper from './mapper/mapper.svelte';
    import History from './history/history.svelte';
    import Header from './header/header.svelte';

    import { deleteLocalStorage, getLocalStorageByKey } from "../../helpers/localstorage";
    import { ROUTES } from "../../helpers/routes";
    
    let currentPath = ''
    const prefix = ROUTES.HOME;
    const routes = {
        [ROUTES.MAPPER]: Mapper,
        [ROUTES.HISTORY]: History,
        // "*": Mapper
    };

    onMount(() => {
        const userToken = getLocalStorageByKey("USER_TOKEN");
        if (!userToken) {
            push(ROUTES.LOGIN);
            return;
        }
        if(userToken) {
            push(getFullRoute(ROUTES.MAPPER));
        }
        location.subscribe((path) => {
            currentPath = path; 
        });
    });

    function getFullRoute(route: string): string {
        return `${prefix}${route}`;
    }

    function onActionClick(route: string) {
        push(getFullRoute(route));
    }
    function onLogout() {
        deleteLocalStorage('USER_TOKEN');
        push(ROUTES.LOGIN);
    }
</script>

<div class="home_container">
    <Header 
        onLogout={onLogout}
        currentPath={currentPath} 
        getFullRoute={getFullRoute} 
        onActionClick={onActionClick} />
    <Router {routes} {prefix} />
</div>

<style lang="scss">
    @import "./home.scss";
</style>
